module.exports = __webpack_public_path__ + "static/media/file-and-store.40bdc592.png";